<section class="animated fadeIn bg_gray height-calc2">
    <div class="breadcrumbArea">
        <div class="container">
            <div class="row justify-content-between align-items-center">
                <div class="col">
                    <nav>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a routerLink="/approval"> <i class="hdr-home"></i></a></li>
                            <li class="breadcrumb-item active">Quick Delegation</li>
                        </ol>
                    </nav>
                </div>
                <div class="col text-right glb-btn justify-content-end pad-bt-1">
                    <button class="btn secondry-button" routerLink="/advanceDeligation">Advanced Delegation</button>
                </div>
            </div>
        </div>
    </div>



    <div class="container">
        <div class="cardContainer">
            <table class="quickDL">
                <thead>
                    <tr>
                        <th width="500">
                            <label class="checkbox-label ">
                                <input type="checkbox" class="check1" [(ngModel)]="isAllAppCheck"
                                    (change)="IsUncheckAllApps($event.target.checked)">
                                <span class="checkbox-custom"></span>
                                <h4 class="checkText tableHd"> Application Name </h4>
                            </label>
                        </th>
                        <th  style="padding-top: 16px !important; padding-bottom: 16px !important">Role</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let activeApp of ActiveAppliactionList || []; let i=index ">
                        <td *ngIf="ActiveAppliactionList?.length">
                            <label class="checkbox-label ">
                                <input type="checkbox" class="check1" [(ngModel)]="activeApp.checkapp"
                                    (change)="updateAppNameOptions(activeApp.appId,$event.target.checked)">
                                <span class="checkbox-custom"></span>
                                <h4 class="checkText tableHd"> {{activeApp.appDecs}} ({{activeApp.appName}}) </h4>
                            </label>
                        </td>
                        <td *ngIf="activeApp.roleAndSubRole?.length > 0 || activeApp.roleAndSubRole != undefined">
                            <ul class="selectRow">
                                <li *ngFor="let activeRole of activeApp.roleAndSubRole;let it =index">
                                    <label class="checkbox-label-role customLabel">
                                        <input *ngIf="activeApp.isAdvDelegated == false " type="checkbox" class="check1"
                                            [(ngModel)]="activeRole.check"
                                            (change)="updateAppNameOptions(activeApp.appId,$event.target.checked)">
                                        <span *ngIf="activeApp.isAdvDelegated == false " class="checkbox-custom">
                                            {{activeRole.RoleName}}</span>
                                        <span *ngIf="activeApp.isAdvDelegated == true ">
                                            {{activeRole.DisplayMsg}}</span>
                                        <span *ngIf="activeApp.isAdvDelegated == false " class="customCheck"></span>

                                    </label>

                                </li>
                            </ul>
                            <a class="editIcon" *ngIf="!activeApp.isRoleAndSubRoleAvi"
                                routerLink="/advanceDeligation"><i class="hdr-edit-normal"></i></a>
                        </td>
                        <td>
                            <ul class="selectRow">
                                <li>
                                    <label class="checkbox-label-role customLabel" >
                                        <span *ngIf="activeApp.isRoleAndSubRoleAvi && activeApp.DisplayMsg"> {{activeApp.DisplayMsg}}
                                        </span>
                                        <span *ngIf="activeApp.isConnectivity"> There's some connectivity issue with
                                            this application. Please try later !
                                        </span>
                                    </label>
                                </li>
                            </ul>
                            <!-- <a class="editIcon"><i class="hdr-edit-normal"></i></a> -->
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="formWarp">
            <div class="row">
                <div class="col-md-4">
                    <div class="FormField2">
                        <label class="custom-label" >Select Delegatee</label>
                        <div class="posRel">
                            <p-autoComplete [(ngModel)]="searchText" [suggestions]="filteredBrands"
                                (completeMethod)="filterBrands($event)" [size]="30" [minLength]="1"
                                placeholder="Search By Name or User ID" panelStyleClass="panelClass"
                                (onKeyUp)="FetchEmployeeSuggestion($event)" (onSelect)="updateDelegateeId($event)">
                            </p-autoComplete>
                            <i class="icon-search"></i>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <label class="custom-label">Select Duration</label>
                    <div class="FormField calenderFild">
                        <p-calendar appendTo="body" dateFormat="dd-M-y" placeholder="Date Range" [minDate]="minDate"
                            [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true" [numberOfMonths]="2"
                            [showIcon]="true" (onSelect)="moveDate()"></p-calendar>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="FormField">
                        <label class="custom-label">Delegation Remarks</label>
                        <div class="posRel">
                            <input appChar maxlength="500" [(ngModel)]="remarks" type="text" class="form-control"
                                placeholder="Due to non-availability in office." pInputText
                                (change)="onRemarkschecked(remarks)">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 mt-16 mb-24">
                    <label class="checkbox-label ml-0">
                        <input type="checkbox" class="check1" [(ngModel)]="DelegatorChecked"
                            (change)="onDelegatorchecked($event.target.checked)">
                        <span class="checkbox-custom"></span>
                        <h4 class="checkText tableHd ml-8">I agree, Delegator will continue to be responsible for all
                            actions taken by Delegatee</h4>
                    </label>
                </div>
            </div>
        </div>

    </div>
</section>

<div class="glb-btn pb-24 pt-24 d-flex justify-content-center pos-sticky border-t-1-gray">
    <button class="btn secondry-button" (click)="reloadWindow()">Cancel</button>
    <button (click)="ShowSuccess()" type="button" class="btn primary-button">Submit</button>
</div>

<!-- plus Five Popover  -->
<ng-template #revokeTemplate>
    <div class="Revoke">
        <ul class="selectRow">
            <li>
                <label class="checkbox-label-role customLabel">
                    <input type="checkbox" class="check1" [(ngModel)]="child27" (change)="child()">
                    <span class="checkbox-custom">CORP-HR-HEAD</span>
                    <span class="customCheck"></span>
                </label>
            </li>
            <li>
                <label class="checkbox-label-role customLabel">
                    <input type="checkbox" class="check1" [(ngModel)]="child28" (change)="child()">
                    <span class="checkbox-custom">CUST-ROLE</span>
                    <span class="customCheck"></span>
                </label>
            </li>
            <li>
                <label class="checkbox-label-role customLabel">
                    <input type="checkbox" class="check1" [(ngModel)]="child29" (change)="child()">
                    <span class="checkbox-custom">SBU-FIN</span>
                    <span class="customCheck"></span>
                </label>
            </li>
            <li>
                <label class="checkbox-label-role customLabel">
                    <input type="checkbox" class="check1" [(ngModel)]="child30" (change)="child()">
                    <span class="checkbox-custom">FIN-SUPER</span>
                    <span class="customCheck"></span>
                </label>
            </li>
            <li>
                <label class="checkbox-label-role customLabel">
                    <input type="checkbox" class="check1" [(ngModel)]="child31" (change)="child()">
                    <span class="checkbox-custom"> FIN-REGION </span>
                    <span class="customCheck"></span>
                </label>
            </li>
        </ul>
    </div>
</ng-template>

<!-- Add Application(S) Popover  -->
<ng-template #addApp>
    <div class="addAppDiv">
        <div class="row">
            <div class="col-md-6 col-sm-6">
                <div class="addedA">
                    <p class="appLabel">Added Applications</p>
                    <ul class="addAppUl active">
                        <li>Billing Request (BRQ)</li>
                        <li>Global Claim (GCS)</li>
                        <li>Leave Management (LMS)</li>
                        <li>Resource Assignation (RAS)</li>
                        <li>Time Sheet Management (iTime)</li>
                        <li>Travel Authorisation (TAS)</li>
                        <li [hidden]="!addApps">Expense Claim</li>
                        <li [hidden]="!addApps1">GEO Joining Console</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6 col-sm-6">
                <div class="selectA">
                    <p class="appLabel">Select Applications</p>
                    <ul class="addAppUl brLeft">
                        <li (click)="addSpoc()" [hidden]="!selectApp">Expense Claim</li>
                        <li (click)="addSpoc1()" [hidden]="!selectApp1">GEO Joining Console</li>
                        <li>iOnBoard</li>
                        <li>iRemunerate</li>
                        <li>Comp Planner</li>
                        <li>ACSAT-SMS</li>
                        <li>Capex</li>
                        <li>Cash Voucher Claim</li>
                        <li>Project Initiation & Budgeting</li>
                        <li>Smart Recruit</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- alertTemp -->
<ng-template #alertTemp>
    <div class="mtable">
        <div class="mCell">
            <h4 (click)="modalRef.hide()" class="closeS"></h4>
            <span class="alertIcon"> <i class="hdr-attention"></i> </span>
            <h3>Are you sure you want to submit request?</h3>
            <div class="glb-btn mt-48 glb-btn">
                <button (click)="modalRef.hide()" class="btn secondry-button">No</button>
                <button (click)="modalRef.hide(); showSuccess()" class="btn primary-button">Yes</button>
            </div>
        </div>
    </div>
</ng-template>




<!-- Reject Modal Box Start  -->
<div bsModal #rejectModal="bs-modal" class="modal fade myModal" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-body d-flex justify-content-center">
                <div class="mCell text-center">
                    <span class="alertIcon"> <i class="hdr-attention"></i> </span>
                    <h3>Are you sure you want to submit request?</h3>
                    <div class="glb-btn mt-40">
                        <button (click)="rejectModal.hide();PostCancelRequest()" class="btn secondry-button">No</button>
                        <button type="button" class="btn primary-button"
                            (click)="rejectModal.hide(); postAddDelegateRequest(); ">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Approve Modal Box Start  -->

<ng-template #approvedModal>
    <div class="modal-body successModal">
        <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="modalRef?.hide(); hideSuccessMsg()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
        <div class="mtable">
            <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="sucImg" /> </span>
            <!-- <pre [innerHTML]="reqStatusRemarks | safe: 'html'"></pre> -->
            <p *ngFor='let message of reqStatusRemarks;'>{{message}}</p>
            <!-- {{reqStatusRemarks | safehtml}} -->
        </div>
    </div>
</ng-template>

<ng-template #validationTemp>
    <div class="mtable">
        <div class="mCell">
            <h4 (click)="modalRef.hide()" class="closeS"><i class="icon-cancel"></i></h4>
            <span class="alertIcon"> <img [src]="alertIcon" /> </span>
            <h3>Please select any application and it's roles before submit.</h3>
            <div class="glb-btn">
                <button (click)="modalRef.hide(); " class="primary-button">OK</button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #validationDelegatee>
    <div class="mtable">
        <div class="mCell">
            <h4 (click)="modalRef.hide()" class="closeS"><i class="icon-cancel"></i></h4>
            <span class="alertIcon"> <img [src]="alertIcon" /> </span>
            <h3>Please select Delegatee</h3>
            <div class="glb-btn">
                <button (click)="modalRef.hide(); " class="primary-button">OK</button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #validationDate>
    <div class="mtable">
        <div class="mCell">
            <h4 (click)="modalRef.hide()" class="closeS"><i class="icon-cancel"></i></h4>
            <span class="alertIcon"> <img [src]="alertIcon" /> </span>
            <h3>Please select Duration</h3>
            <div class="glb-btn">
                <button (click)="modalRef.hide(); " class="primary-button">OK</button>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #DelegatorConsen>
    <div class="mtable">
        <div class="mCell">
            <h4 (click)="modalRef.hide()" class="closeS"></h4>
            <span class="alertIcon"> <i class="hdr-attention"></i> </span>
            <h3>Provide Delegator Consent.</h3>
        </div>
    </div>
</ng-template>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

<p-dialog [(visible)]="diswarmingQuickDele" position="top" [draggable]="false" [modal]="true" styleClass="confirmMsg">
    <div class="thankMsg">
        <img src="assets/fonts/Error.svg" alt="">
        <p>{{errorOndehalfDelegation}}</p>
    </div>
</p-dialog>

<ng-template #alertModal>
    <div class="modal-body successModal">
        <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="modalRef?.hide(); hideSuccessMsg()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
        <div class="mtable">
            <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="alertImg" /> </span>
            <p class="">{{errorOndehalfDelegation}}</p>
        </div>
    </div>
</ng-template>

<ng-template #alertSuccErrorModal>
    <div class="modal-body successModal">
        <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="modalRef?.hide(); hideSuccessMsg()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
        <div class="mtable">
            <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="alertImg" /> </span>
            <!-- <pre [innerHTML]="errorOndehalfDelegation | safe: 'html'"></pre> -->
             <p>{{errorOndehalfDelegation}}</p>
        </div>
    </div>
</ng-template>


<ng-container *ngIf="visible1">
    <div class="toast-warp" #quick>
        <p>{{errorOndehalfDelegation}}</p>
        <button (click)="quick.hidden = !quick.hidden;OnClick()" type="button" aria-label="Close"
            class="btn-close close pull-right"><span aria-hidden="true" class="hdr-cancel"></span></button>
    </div>
</ng-container>
<ng-template #alertSuccErrorModalMultiLine>
    <div class="modal-body successModal">
        <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="modalRef?.hide(); hideSuccessMsg()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
        <div class="mtable">
            <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="alertImg" /> </span>
            <!-- <pre [innerHTML]="errorOndehalfDelegation | safe: 'html'"></pre> -->
             <p *ngFor='let message of errorOndehalfDelegationMultiError;'>{{message}}</p>
        </div>
    </div>
</ng-template>